import React, { Component, Fragment } from 'react';
import { Grid, Form } from 'semantic-ui-react';
import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form';
import { withRouter } from 'react-router';

import { CEP_SETUP_FORM_NAME } from 'Common/FormEnum';
import { CEPSetupFieldEnum as Fields } from 'Common/FieldEnum';
import { CEPSetupTable } from './CEPSetupTable';

class FiscalYearContainer extends Component {
  render() {
    const { formValues } = this.props;
    return (
      <Fragment>
        <Form name={CEP_SETUP_FORM_NAME}>
          <Grid>
            <Grid.Row>
              <Field
                name={Fields.Sites}
                component={CEPSetupTable}
                data={formValues[Fields.Sites]}
                sitesLoading={this.props.sitesLoading}
              />
            </Grid.Row>
          </Grid>
        </Form>
      </Fragment>
    );
  }
}

const FiscalYearForm = reduxForm({
  form: CEP_SETUP_FORM_NAME,
  enableReinitialize: true,
})(withRouter(connect()(FiscalYearContainer)));

export { FiscalYearForm };



// WEBPACK FOOTER //
// ./src/pages/cepsetup/components/FiscalYearForm.js